import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: #f8f8f8;
  border-radius: 9px;
  position: relative;
  padding: 10px;
`;

const items = [
  'Create wedding website',
  'Decide on budget',
  'Book Ceremony venue',
  'Create shortlist of Photographers',
  'Finalise your guest list',
];

const Table = styled.div`
  max-width: 500px;
  width: 100%;
  position: relative;
  z-index: 10;
`;

const Row = styled.div`
  align-items: flex-start;
  background: ${props => (!props.active ? 'transparent' : '#fff')};
  box-shadow: ${props =>
    props.active
      ? '0 19px 45px rgba(99,99,99, 0.15),0 0px 19px rgba(99,99,99, 0.08);'
      : '0 19px 45px rgba(99,99,99, 0),0 0px 19px rgba(99,99,99, 0)'};
  display: flex;
  flex-direction: row;
  font-size: 0.8em;
  justify-content: flex-start;
  opacity: ${props => (props.active ? '1' : '0.65')};
  padding: 1.3em 0.8em;
  position: relative;
  transform: ${props => (props.active ? 'scale(1.11)' : 'none')};
  transition: transform 0.75s, box-shadow 0.5s, background-color 0.3s;
  z-index: ${props => (props.active ? '4' : '1')};
`;
const Col = styled.div`
  display: block;
  flex: ${props => props.grow};
  margin: 0 10px 0 0;
`;

const Value = styled.div`
  padding: 3px 0;
  font-size: 13px;
  border-radius: 2px;
  transition: width 0.5s;
`;

const Tick = styled.div`
  background: #fff;
  border: solid 1px transparent;
  border-color: ${props => (props.done ? '#388070' : '#ccc')};
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  position: relative;
  transition: border-color 0.3s 0.3s;
  font-weight: 700;
  margin: 0 0 0 10px;

  &:after {
    content: ' ';
    border-bottom: solid 3px #388070;
    border-right: solid 3px #388070;
    width: 4px;
    height: 8px;
    position: absolute;
    top: 0.17em;
    transform: ${props => (props.done ? 'scale(1)' : 'scale(2)')} rotate(45deg);
    opacity: ${props => (props.done ? '1' : '0')};
    transition: opacity 0.3s 0.3s, transform 0.3s 0.3s;
    left: 0.4em;
  }
`;

const timeout = 1800;

function CollectionGraphic() {
  const [active, setActive] = useState(2);
  const max = items.length - 1;

  useEffect(() => {
    const tick = () => {
      setActive(prevActive => (prevActive < max ? prevActive + 1 : 0));
    };
    const timerId = window.setTimeout(tick, timeout);
    return () => window.clearTimeout(timerId);
  }, [active, max]);

  return (
    <Wrapper>
      <Table>
        {items.map((el, id) => {
          let isActive = id === active;
          let persist = id < active;
          return (
            <Row key={id} active={isActive} alt={id % 2}>
              <Col grow={0}>
                <Tick done={isActive || persist} />
              </Col>
              <Col grow={2} mobile="hide">
                <Value active={isActive} delay={1} persist={persist}>
                  {el}
                </Value>
              </Col>
            </Row>
          );
        })}
      </Table>
    </Wrapper>
  );
}

export default CollectionGraphic;
